import { render, staticRenderFns } from "./ProfileActionButton.vue?vue&type=template&id=71aa4176&"
import script from "./ProfileActionButton.vue?vue&type=script&lang=js&"
export * from "./ProfileActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports